import React, { useEffect } from "react";
import ReactGA from "react-ga4";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import ThoughtBoxPage from "./pages/ThoughtBoxPage";
import Home from "./pages/home";
import BlogsPage from "./pages/BlogsPage";
import ConversationsPage from "./pages/ConversationsPage";
import AIInJudiciary from "./pages/blogs/AIInJudiciary";
import GraphSummit25 from "./pages/blogs/GraphSummit25";
import GenAIvsConAI from "./pages/blogs/GenAIvsConAI";
import AskVijay from "./pages/blogs/AskVijay";

const TRACKING_ID = "G-6J126TXW81";

// Custom hook to track page views
const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname });
  }, [location]);
};

function App() {
  useEffect(() => {
    ReactGA.initialize(TRACKING_ID); // 🔹 Initialize GA when the app loads
  }, []);
  return (
    <Router>
      <PageTracker /> {/* Tracks page views on route changes */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/blogs" element={<BlogsPage />} />
        <Route path="/conversations" element={<ConversationsPage />} />
        <Route path="/about" element={<ThoughtBoxPage />} />
        <Route path="/blog/ai-in-judiciary" element={<AIInJudiciary />} />
        <Route path="/blog/graphsummit-25" element={<GraphSummit25 />} />
        <Route path="/blog/genai-vs-conai" element={<GenAIvsConAI />} />
        <Route path="/blog/askVijay" element={<AskVijay />} />
        {/* Add other routes here */}
      </Routes>
    </Router>
  );
}

// Component to apply the tracking hook
const PageTracker = () => {
  usePageTracking();
  return null;
};

export default App;
